import { z } from 'zod';
import { createZodDto } from 'nestjs-zod';

export const device = z.object({
  id: z.number(),
  certificate: z.string(),
});

export class DeviceDto extends createZodDto(device) {}
